import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export class ArrayFormValidators {
  public static unique(compareFn = (a: unknown, b: unknown) => a === b): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!('length' in control)) {
        return null;
      }

      const formArray = control as FormArray;

      for (let i = 0; i < formArray.controls.length - 1; i = i + 1) {
        for (let j = i + 1; j < formArray.controls.length; j = j + 1) {
          const ctrl1 = formArray.controls.at(i);
          const ctrl2 = formArray.controls.at(j);
          if (ctrl1?.value && ctrl2?.value) {
            if (compareFn(ctrl1.value, ctrl2.value)) {
              return { notUnique: true };
            }
          }
        }
      }

      return null;
    };
  }

  public static notIfMultiple(date: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!('length' in control)) {
        return null;
      }

      const formArray = control as FormArray;

      if (formArray.controls.length > 1) {
        if (formArray.controls.some(control => control.value === date)) {
          return { invalidDate: date };
        }
      }

      return null;
    };
  }
}
